import { usePropertyGeneralContractorName } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { TextBox } from '@apply/components';
import { ApplicationNonRentalFieldLength } from '@apply/constants';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface GeneralContractorCompanyProps {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const GeneralContractorCompany: React.FC<GeneralContractorCompanyProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'G. C. Company Name';
    const [generalContractorCompany, set_generalContractorCompany] = usePropertyGeneralContractorName(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={generalContractorCompany}
                />
            ) : (
                <TextBox
                    id='generalContractorName'
                    value={generalContractorCompany}
                    onChange={(value) => set_generalContractorCompany(value)}
                    label={label}
                    required={required}
                    width='100%'
                    maxLength={ApplicationNonRentalFieldLength.generalContractorName}
                />
            )}
        </>
    );
};
